module.exports = "<div ui-view>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/maneuver/unpark/templates/index.html
// module id = 1605
// module chunks = 0